<template>
  <tbody>
    <table-tr v-for="row in rows" :key="row" :data="row" />
  </tbody>
</template>

<script>
import TableTr from './tr'
export default {
  name: 'TableTbody',
  components: { TableTr },
  props: {
    rows: {
      default: () => [],
      required: false,
      type: Array
    }
  }
}
</script>
